// Stable ids of the required ABHA-creation consent statements (R80 contract, order matters).
export const ABHA_CONSENT_STATEMENT_IDS = [
  'AADHAAR_EKYC_SHARE',
  'LINK_HEALTH_RECORDS',
  'SHARE_WITH_PROVIDERS',
  'ANONYMISED_PUBLIC_HEALTH',
];
